<template>
  <v-app>
    <AppBar />
    <main class="app-main">
      <router-view />
    </main>
    <AppFooter />
  </v-app>
</template>

<script>
import AppBar from './components/AppBar.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppBar,
    AppFooter
  }
}
</script>

<style>
.app-main {
  padding-top: 64px;
}
</style>
